import { Container, Graphics, FillGradient, Color, ColorSource, Ticker, } from "pixi.js";
import { app,  killBackground,  menuGraphics,  mobileView,  resetBackground } from "../app";

import { currentPalette } from "../palettes";
import { interpColour } from "../utils/customMaths";
import { findSettingByID, settingValue } from "../settings";
import gsap from "gsap";
import { graphicsContainer } from "./MenuGraphics";
import { headingsContainer } from "../screens/default";
import { ViewportInstance } from "./ViewportInstance";
import { ViewportText } from "./ViewportText";
import { ViewportSprite } from "./ViewportSprite";

// const MENU_COLOUR_1 = currentPalette.back1;
const TOP_POSITION = -0.6;
const BOTTOM_POSITION = 3.0;

const html = document.getElementById('menu');
const options = document.getElementById('options');



export class Menu extends Container {

    
    private g;
    private back;
    private back2;
    public droppedPercent: number = TOP_POSITION;
    public isActive: boolean = false;
    public isMoving: boolean = false;
    private currentColour: number = currentPalette.back1;
    // private finalColour: number = MENU_COLOUR_1;
    private points: number[][] = Array.from({ length: 11 }, () => [
        0,                    
        0,
        0, //time delay
        0,
    ]);
    private container = new Container;
    private colours: ColorSource[] = new Array(2);
    private colourUpdate;
    private settings: number[] = new Array(4);

    baseGradient = new FillGradient({
            type: 'linear',
            start: { x: 0, y: 0 },  // Start at top
            end: { x: 0, y: app.renderer.height }, 
            colorStops: [
                { offset: 0, color: new Color('white') },
                { offset: 1, color: new Color('white')},
            ],
            textureSpace: 'global'
            });

    private mainGradient = new FillGradient({...this.baseGradient})
    private backGradient = new FillGradient({...this.baseGradient})
    private backGradient2 = new FillGradient({...this.baseGradient})
    // private backGradient = new Color;
    // private backGradient2 = new Color;
    
    private targetAlpha = 0;
    private currentAlpha = 0;

    constructor(){

        super();

        

        this.g = new Graphics();
        
        this.back = new Graphics();
        this.back._zIndex = -1;
        this.back2 = new Graphics();
        this.back2._zIndex = -2;
        

        this.addChild(this.g)
        this.addChild(this.back)
        this.addChild(this.back2)
        app.stage.addChild(this)

        //intensive for no reason definitely a better way to do this; makes pixelated
        // this.g.filters = [
        //     new ColorReplaceFilter
        // ]
        // this.back.filters = [
        //     new ColorReplaceFilter
        // ]
        // this.g.filters = [
        //     new ColorReplaceFilter
        // ]

        

        //set colour update ticker functionality
        this.colourUpdate = () => {
           
            if (this.settings[0] === 1) {

                this.mainGradient = new FillGradient({...this.baseGradient,
                        colorStops: [
                            { offset: 0, color: new Color(currentPalette.back1) },
                            { offset: 1, color: new Color(currentPalette.back2)},
                        ],
                        end: { x: 0, y: app.renderer.height }, 
                    }
                );
                //extra layers won't be seen until movement, so can withhold calculations until animation started
                // if (this.isMoving) {
                    this.backGradient = new FillGradient({...this.mainGradient,
                            start: { x: 0, y: 0},  // Start at top
                            end: { x: 0, y: app.renderer.height*1.5 }, 
                        }
                    );
                    
                    this.backGradient2 = new FillGradient({...this.mainGradient,
                            start: { x: 0, y: -app.renderer.height/2 },  // Start at top
                            end: { x: 0, y: app.renderer.height}, 
                        }
                    );
                // }
                
            } else {
                
                this.colours = [ 
                    interpColour(currentPalette.back1, currentPalette.back2, 0.3),
                    interpColour(currentPalette.back1, currentPalette.back2, 0.8)
                ]
                
            }
            
        }

        this.updateSettings();

        app.ticker.add(() => {            

            if (this.isActive || this.isMoving) {

                this.g.clear();
                this.back.clear()
                this.back2.clear()

                if (this.isMoving && menuGraphics) {
                    menuGraphics.resize();
                }

                const pointReduction = mobileView? 5: 0;
                
                const height = app.renderer.height;
                const width = (app.renderer.width + 50)

                let divWidth = width/(this.points.length-1- pointReduction);

                //calculate points x position relative to screen width;
                this.points.forEach( (point, index) => {
                    point[0] = divWidth * index
                    if (point[2] > 0.0) point[2] = point[2]/1.05 //removes delay, delay is added when activating menu
                    point[3] = point[2] < 10 ? 1 - point[2]/10 : 0;
                })
                

                const startX = -20 ;
                const startY = height*this.droppedPercent -20;

                this.g.moveTo(startX, startY);
                if (this.settings[2] === 1) {
                    this.back.moveTo(startX, startY-height/10)
                    this.back2.moveTo(startX, startY);
                }
                

                let lastX = startX;
                let point = 0; //track which points have been moved past

                let lastY = 0;
                let currentY = 0;

            

                for(let x= startX; x <= width - startX; x+= 15) {

                    //updating latest point
                    while(point + 2 !== this.points.length && x > this.points[point+1][0]) {
                        
                        
                        point++;
                    }

                    lastY = this.points[point][1] * this.points[point][3]; 
                    currentY = this.points[point+1][1] * this.points[point+1][3];
                    
                    const divPercent = (x-this.points[point][0])/divWidth;
                    // const yInterp = lastY + (currentY-lastY)*divPercent;
                    const wave = (1 - Math.cos(divPercent * Math.PI))
                    const yInterp = lastY + (currentY - lastY) * (wave/2);
                    
                    const y =  height*this.droppedPercent - height*1 
                    + (-0.5+yInterp)*height/4 ;
                    lastX = x;
                    this.g.lineTo(x,y);
                    if (this.settings[2] === 1) {
                        this.back.lineTo(x+6,y-height/20 + (-0.5+yInterp)*height/8)
                        this.back2.lineTo(x,y-height/15 + (-0.5+yInterp)*height/4)
                    }
                }

                for(let x = lastX; x>= startX; x -= 15) {

                    //updating latest point
                    while(point !== 1 && x < this.points[point][0]) {                                
                        point--;
                    }

                    lastY = this.points[point][1] * this.points[point][3]; 
                    currentY = this.points[point-1][1] * this.points[point-1][3];
                    
                    const divPercent = (x-this.points[point-1][0])/divWidth;
                    // const yInterp = lastY + (currentY-lastY)*divPercent;
                    const wave = (1 - Math.cos(divPercent * Math.PI))
                    const yInterp = lastY + (currentY - lastY) * (wave/2);

                    const y = height*this.droppedPercent -  yInterp*height/4 ;

                    this.g.lineTo(x,y);
                    if (this.settings[2] === 1) {
                        this.back.lineTo(x+6,y+height/20 -  yInterp*height/8)
                        this.back2.lineTo(x,y+height/7 -  yInterp*height/4)
                    }
                }

                if (this.settings[0] === 1) {
                    if (this.mainGradient)
                    this.g.fill(this.mainGradient);
                    if (this.settings[2] === 1) {
                        if (this.backGradient)
                        this.back.fill(this.backGradient)
                    if (this.backGradient)
                        this.back2.fill(this.backGradient2)
                    }
                } else {
                    this.g.fill(this.colours[0]);
                    if (this.settings[2] === 1) {
                        this.back.fill(currentPalette.back1)
                        this.back2.fill(this.colours[1])
                    }
                }
                

                this.g.closePath();
                // console.log(this.currentAlpha, this.targetAlpha)
                if (!this.isMoving) {
                    if (this.currentAlpha > this.targetAlpha) {
                        this.currentAlpha = Math.max(this.targetAlpha, this.currentAlpha - 0.05);
                    } else if (this.currentAlpha < this.targetAlpha) {
                        this.currentAlpha = Math.min(this.targetAlpha, this.currentAlpha + 0.05);
                    }
                }
                this.g.alpha = this.currentAlpha;
                if (this.settings[2] === 1) {
                    this.back.closePath();
                    this.back2.closePath();
                }

                if  (this.isActive && !this.isMoving) {
                    this.back.alpha = 0;
                    this.back2.alpha = 0;
                } else {
                    if (this.currentAlpha <1) {
                        this.back.alpha = this.currentAlpha/3
                        this.back2.alpha = this.currentAlpha/3
                    } else {
                        this.back.alpha = 1;
                        this.back2.alpha = 1;
                    }
                    
                }

                //change menu selector heading location
                const oldContainerPos = headingsContainer.y;
                headingsContainer.y = height*(this.droppedPercent-1);
                if (oldContainerPos !== headingsContainer.y) {
                    headingsContainer.children.forEach(child=> {if (child instanceof ViewportText || child instanceof ViewportSprite) child.updatePixel()})
                }
            }

            //change text position
            if (html)
            html.style.setProperty('--yOffset', `${100*(this.droppedPercent-1)}dvh`); 

            
        })

    }

    
    private animateDrop(target: number) {    
        gsap.to(this, {
            droppedPercent: target,
            duration: this.isActive ? 0.7 : 1.4,
            ease: this.isActive ? "sine.in"  : "back.out(0.4)",

            // onUpdate: () => {                                                        
            // },

            onComplete: () => {
                this.isMoving = false;

                if (this.isActive) {
                    
                    //enable scroll bars
                    if (options) {
                        options.style.removeProperty("overflow-x");
                        options.style.removeProperty("overflow-y");
                    }
                    if (settingValue(findSettingByID(36)) === 0) {
                        killBackground();
                    }
                } else {
                    const options = document.getElementById('menu');
                    options?.style.setProperty("visibility", "hidden");
                    this.droppedPercent = TOP_POSITION;
                }
            }
        });
    }

    public activate(){
        if (this.isMoving) return;
        
        //disable scroll bar
        if (options) {
            options.style.setProperty("overflow-x", "hidden", "important");
            options.style.setProperty("overflow-y", "hidden", "important");
        }
        this.isMoving = true;
        //choose random offsets
        this.points.forEach( (point, index) => {
                point[1] = Math.random() * -1 // UNUSED?
                point[2] = Math.random() * 20 + 12 //delay
                // point[4] = point[2] + 10 //extra delay for second layer
            })
        if (this.isActive) {
            // this.targetAlpha = 1;
            const waitDrop = () => {
                if (this.currentAlpha >= 1) {
                    app.ticker.remove(waitDrop); //remove this from ticker
                    this.currentAlpha = 1;
                    this.animateDrop(BOTTOM_POSITION)
                    if (settingValue(findSettingByID(36)) === 0) {
                        resetBackground();
                    }
                    this.isActive = !this.isActive;
                } else {
                    this.currentAlpha += (1-this.targetAlpha)/10;
                }
            }
            app.ticker.add(waitDrop);
            
            
        } else {
            this.currentAlpha = 1;
            this.animateDrop(1)
            const options = document.getElementById('menu');
            options?.style.setProperty("visibility", "visible");
            this.isActive = !this.isActive;
        }
        
        
        console.log(this.isActive)
        this.colourUpdate()
        
    }

    //slowly fades to new palette colours
    public updateColour(isOn: boolean){
        console.log("updating colours")
        if (isOn) {
        app.ticker.add(this.colourUpdate)
        
        }
        
        else {
            app.ticker.remove(this.colourUpdate);
            this.colourUpdate();
        }
    }



    public updateSettings(){
        if (settingValue(findSettingByID(36)) === 1 ) {
            const viewMode = settingValue(findSettingByID(43));
            if (viewMode === undefined) {
                this.targetAlpha = 0.25
            } else {
                switch (viewMode) {
                    case 0: 
                        this.targetAlpha = 0.1;
                        break;
                    case 4: 
                        this.targetAlpha = 0.25;
                        break;
                    case 1: 
                        this.targetAlpha = 0.5;
                        break;
                    case 2: 
                        this.targetAlpha = 0;
                        break;
                    default:
                        this.targetAlpha = 0.25;
                        break;
                }
                
            }
        } else {
            this.targetAlpha = 1;
            this.currentAlpha = 1;
        }
        //gradients
        if (settingValue(findSettingByID(40)) === 1) {
            this.settings[0] = 1
            
            this.colourUpdate(); //Run update once to reform gradients
        } else {
            this.settings[0] = 0
            //can't safely destroy anywhere....
            // this.mainGradient?.destroy();
            //     this.backGradient?.destroy();
            //     this.backGradient2?.destroy();
        }
        if (settingValue(findSettingByID(41)) === 1) {
            this.settings[1] = 1
        } else {
            this.settings[1] = 0
        }
        if (settingValue(findSettingByID(42)) === 1) {
            this.settings[2] = 1
        } else {
            this.settings[2] = 0
        }
    }
}


